import * as echarts from "echarts";

let charts = [];

function initializeCharts() {
    let chartContainers = document.querySelectorAll(".eChartDonut");

    chartContainers.forEach((chartContainer, index) => {
        let chartDataJson = chartContainer.getAttribute("data-chart");

        let chartData;
        try {
            chartData = JSON.parse(chartDataJson);
        } catch (error) {
            console.error("Error parsing JSON data:", error);
            return;
        }

        let titleText = chartData.datasets[0].title || "Default Title";

        // Function to break text at spaces
        function wrapText(text, maxWordsPerLine = 1) {
            let words = text.split(" "); // Split by spaces
            let lines = [];
            for (let i = 0; i < words.length; i += maxWordsPerLine) {
                lines.push(words.slice(i, i + maxWordsPerLine).join(" "));
            }
            return lines.join("\n"); // Join lines with newlines
        }

        let wrappedTitle = wrapText(titleText, 1);

        let myChart =
            charts[index] ||
            echarts.init(chartContainer, null, { renderer: "svg" });

        let option = {
            tooltip: {
                trigger: "item",
                confine: true, // Keeps tooltip inside the container
                position: function (point, params, dom, rect, size) {
                    let x = point[0]; // X coordinate of the mouse
                    let y = point[1]; // Y coordinate of the mouse
                    let boxWidth = size.contentSize[0]; // Tooltip width
                    let boxHeight = size.contentSize[1]; // Tooltip height
                    let chartWidth = size.viewSize[0]; // Chart container width
                    let chartHeight = size.viewSize[1]; // Chart container height

                    // Adjust position if tooltip is near the edges
                    if (x + boxWidth > chartWidth) {
                        x -= boxWidth; // Move left if overflow on right
                    }
                    if (y + boxHeight > chartHeight) {
                        y -= boxHeight; // Move up if overflow on bottom
                    }

                    return [x, y]; // Return adjusted tooltip position
                },
            },
            legend: {
                show: false,
            },
            series: [
                {
                    name: chartData.datasets[0].title,
                    type: "pie",
                    radius: chartData.datasets[0].radius, // Use correct radius
                    avoidLabelOverlap: true,
                    label: {
                        show: false,
                        position: "center",
                    },
                    emphasis: {
                        label: {
                            show: false,
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: chartData.datasets[0].data.map((value, index) => ({
                        value: parseFloat(value), // Convert from string to number if necessary
                        name: chartData.labels[index],
                    })),
                    itemStyle: {
                        color: (params) =>
                            chartData.datasets[0].backgroundColor[
                                params.dataIndex
                            ],
                    },
                },
            ],
            graphic: [
                {
                    type: "group",
                    left: "center",
                    top: "middle",
                    children: [
                        {
                            type: "text",
                            left: "center",
                            top: "40%",
                            style: {
                                text: wrappedTitle,
                                fontSize: 24,
                                align: "center",
                                textAlign: "center",
                                fill: "#070F12",
                                width: 100,
                                lineHeight: 32,
                            },
                        },
                    ],
                },
            ],
        };

        try {
            myChart.setOption(option);
        } catch (error) {
            console.error("Error setting chart option:", error);
        }

        // Update charts array to keep track of initialized charts
        charts[index] = myChart;
    });
}

document.addEventListener("DOMContentLoaded", initializeCharts);
